import { render } from "./edit-user-modal.vue?vue&type=template&id=5d4d756c"
import script from "./edit-user-modal.vue?vue&type=script&lang=js"
export * from "./edit-user-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__